<template>
  <div class="code">
    <div class="rc-datetime"></div>
    <div class="code-info">
      <div class="qr-code">
        <qrcode-scan
          :type="QRSCAN_COMPANY_CHECKIN_ACTION"
          :formatOfData="CHECKIN_COMPANY_DATA_FORMAT"
          @onDecode="handleOnDecode($event)"
        ></qrcode-scan>
        <div class="widget-button py-5 text-center">
          <router-link tag="button" :to="pathHome + '/company-code'">
            <v-btn
              depressed
              class="btn-back"
              outlined
              color="#e8320e"
              height="50"
              >{{ $t('scan-success-page.btn-back', { split: '/' }) }}</v-btn
            >
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  QRSCAN_COMPANY_CHECKIN_ACTION,
  CHECKIN_COMPANY_DATA_FORMAT
} from '@/common/constants';
import QrScan from '@/components/QRCode/QRCodeScan.vue';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'Company-QrScan',

  components: {
    'qrcode-scan': QrScan
  },
  data: () => ({
    QRSCAN_COMPANY_CHECKIN_ACTION,
    CHECKIN_COMPANY_DATA_FORMAT
    // data: {
    //   exhibiting_company_id: 19
    // }
  }),
  validations: {
    entryCode: {
      required
    }
  },
  watch: {
    // checkInData: function(val, oldVal) {
    //   console.log(val);
    //   if (val !== oldVal) {
    //     this.$router.push({ name: 'scan-success', query: { type: 'qr-scan' } });
    //   }
    // }
  },

  methods: {
    handleOnDecode(value) {
      const { exhibiting_company_id } = value;

      if (exhibiting_company_id) {
        this.$router.push({
          name: 'company-checkin-success',
          params: {
            companyId: exhibiting_company_id
          },
          query: { type: 'qr-scan' }
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      //   checkInData: 'getCheckInData'
    })
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';
@import '@/style/devices.scss';

.qr-code {
  margin-top: 30px;
  margin-bottom: 30px;
  position: relative;

  .error-tip {
    position: absolute;
    top: -34px;
    left: calc(100% / 3 - 30px);
    width: auto;
    min-height: 1.1rem;
    font-size: 11px;
    padding: 5px;

    font-weight: bold;
    background: #f75636;
    border-radius: 4px;
    color: #fff;

    &::after {
      display: block;
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      bottom: -18px;
      left: 12px;
      border: 18px solid transparent;
      border-top: 0px solid #f75636;
      border-left: 12px solid #f75636;
    }
  }
  .camera-qr {
    margin: 0 auto;
  }
}

@include mobile {
  .qr-code {
    margin-top: 30px;
    .v-btn {
      max-width: 80vw !important;
    }
  }
}
</style>
